<template>
	<div class="navview" v-bind:style="styleObject">
		<div class="container">
			<div class="flexspacebetween alignitemscenter" style=" flex-wrap:nowrap;height: 80px; width: 100%;">
				<img class="" style="width: 121px; height: 38px;" v-bind:src="logourl">



				<div class="h2 naviconbutton"  v-on:click="openMiniNav">
					<b-icon icon="list-ul" style="color: #ffffff;"></b-icon>
				</div>


				<div class="navtitleview">
					<div v-bind:class="[selectindex==0  ? 'navtitleselect' :  'navtitle']" style="cursor : pointer"
						v-on:click="gopage('/')">
						<a> 首页 </a>
					</div>
					<div v-bind:class="[selectindex==1 ? 'navtitleselect' :  'navtitle']"
						style="margin-left: 64px;cursor : pointer">
						<a v-on:click="opensubnav(1)"> 创新实验室 </a>
						<img style="width: 16px; height: 16px; " src="../static/svg/down-w.svg">
						<!-- subNav -->
						<div v-if="showsubnav[1]" class="subnavview boxshadow" style="background-color:white">
							<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
								@click="gopage('/newpro/Proclub')">
								创新项目
							</div>
							<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
								@click="gopage('/newpro/ProaiLiuxing')">
								AI流行趋势
							</div>
							<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
								@click="gopage('/newpro/Prodesgin')">
								AI辅助设计平台</div>
							<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
								@click="gopage('/newpro/Prodatapr')">
								时尚产业数字化版权保护平台 </div>
							<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
								@click="gopage('/newpro/Probookclub')">
								数字化材料图书馆</div>
							<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
								@click="gopage('/newpro/Prointenet')">
								工业互联网</div>
							<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
								@click="gopage('/newpro/Pro3d')">
								人体数据扫描 </div>
						</div>
						<!-- subNav End -->
					</div>
					<div v-bind:class="[selectindex==6 ? 'navtitleselect' :  'navtitle']"
						style="margin-left: 48px;cursor : pointer" v-on:click="gopage('/Supply')">
						<a> 供应链服务 </a>
					</div>
					<div v-bind:class="[selectindex==2 ? 'navtitleselect' :  'navtitle']"
						style="margin-left: 48px;cursor : pointer">
						<a v-on:click="opensubnav(2)"> C2M解决方案 </a>
						<img style="width: 16px; height: 16px;stroke: #E8C570; " src="../static/svg/down-w.svg">
						<!-- subNav -->
						<div v-if="showsubnav[2]" class="subnavview boxshadow" style="background-color:white">
							<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
								@click="gopage('/Solution/Fashion')">
								时尚趋势 </div>
							<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
								@click="gopage('/Solution/Aimake')">
								智能制造 </div>
							<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
								@click="gopage('/Solution/Custom')">
								C2M智能定制 </div>
							<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
								@click="gopage('/Solution/Serve')">
								C2M数字化服务 </div>
							<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
								@click="gopage('/Solution/Ordersystem')">
								数字化订货系统 </div>

						</div>
						<!-- subNav End -->
					</div>
					<div v-bind:class="[selectindex==3 ? 'navtitleselect' :  'navtitle']"
						style="margin-left: 48px;cursor : pointer" v-on:click="gopage('/News/List')">
						<a> 新闻中心 </a>
					</div>
					<div v-bind:class="[selectindex==4 ? 'navtitleselect' :  'navtitle']"
						style="margin-left: 64px;cursor : pointer">
						<a v-on:click="opensubnav(4)">关于我们 </a>
						<img style="width: 16px; height: 16px; " src="../static/svg/down-w.svg">
						<!-- subNav -->

						<div v-if="showsubnav[4]" class="subnavview boxshadow" style="background-color:white">
							<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
								@click="gopage('/About')">
								关于我们 </div>
							<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
								@click="gopage('/About/Hr')">
								招贤纳士 </div>
							<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
								@click="gopage('/About/Contact')">
								联系我们 </div>

						</div>
						<!-- subNav End -->


					</div>

				</div>
			</div>
		</div>

		<!-- 竖的导航 -->
		<div v-if="showminiNav" class="navtitleviewleft">
			<div style="cursor : pointer; position: absolute;   top:80px ; left: 0px; ">
				<div v-bind:class="[selectindex==0  ? 'navtitleselect' :  'navtitle']" v-on:click="gopage('/')">
					<a> 首页 </a>
				</div>

				<div style="display: flex;">
					<div v-bind:class="[selectindex==1 ? 'navtitleselect' :  'navtitle']">
						<a v-on:click="opensubnav(1)"> 创新实验室 </a>
					</div>
					<!-- subNav -->
					<div v-if="showsubnav[1]" class="subnavview boxshadow">
						<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
							@click="gopage('/newpro/Proclub')">
							创新项目
						</div>
						<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
							@click="gopage('/newpro/ProaiLiuxing')">
							AI流行趋势
						</div>
						<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
							@click="gopage('/newpro/Prodesgin')">
							AI辅助设计平台</div>
						<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
							@click="gopage('/newpro/Prodatapr')">
							时尚产业数字化版权保护平台 </div>
						<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
							@click="gopage('/newpro/Probookclub')">
							数字化材料图书馆</div>
						<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
							@click="gopage('/newpro/Prointenet')">
							工业互联网</div>
						<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
							@click="gopage('/newpro/Pro3d')">
							人体数据扫描 </div>
					</div>
					<!-- subNav End -->
				</div>

				<div v-bind:class="[selectindex==6 ? 'navtitleselect' :  'navtitle']" v-on:click="gopage('/Supply')">
					<a> 供应链服务 </a>
				</div>

				<div style="display: flex;">
					<div v-bind:class="[selectindex==2 ? 'navtitleselect' :  'navtitle']">
						<a v-on:click="opensubnav(2)"> C2M解决方案 </a>
					</div>
					<!-- subNav -->
					<div v-if="showsubnav[2]" class="subnavview boxshadow">
						<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
							@click="gopage('/Solution/Fashion')">
							时尚趋势 </div>
						<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
							@click="gopage('/Solution/Aimake')">
							智能制造 </div>
						<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
							@click="gopage('/Solution/Custom')">
							C2M智能定制 </div>
						<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
							@click="gopage('/Solution/Serve')">
							C2M数字化服务 </div>
						<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
							@click="gopage('/Solution/Ordersystem')">
							数字化订货系统 </div>

					</div>
					<!-- subNav End -->
				</div>

				<div v-bind:class="[selectindex==3 ? 'navtitleselect' :  'navtitle']" v-on:click="gopage('/News/List')">
					<a> 新闻中心 </a>
				</div>
				<div style="display: flex;">

					<div v-bind:class="[selectindex==4 ? 'navtitleselect' :  'navtitle']" >
						<a v-on:click="opensubnav(4)">关于我们 </a>
					</div>
					<!-- subNav -->

					<div v-if="showsubnav[4]" class="subnavview boxshadow" >
						<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
							@click="gopage('/About')">
							关于我们 </div>
						<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
							@click="gopage('/About/Hr')">
							招贤纳士 </div>
						<div class="subnavitem" @mouseover.stop="showselect" @mouseout="hideenselect"
							@click="gopage('/About/Contact')">
							联系我们 </div>

					</div>
					<!-- subNav End -->
				</div>



			</div>
		</div>
		<!-- 竖的导航end -->

	</div>

</template>

<script>
	import wlogo from '../static/星链数据横版定稿白色logo.png'
	import clogo from '../static/星链数据横版定稿.svg'
	export default {
		name: 'Nav',

		data() {
			return {
				showsubnav: [false, false, false, false, false, false],

				selectindex: 0,
				styleObject: {
					height: '80px',
					backgroundColor: 'rgba(17,22,31,0.9)'
				},
				styleObject2: {

					backgroundColor: 'rgba(17,22,31,0.9)'
				},
				logourl: wlogo,
				showminiNav:false,

			}
		},
		mounted() {
			console.log("Hi,Welcom")
			console.log("Auth：k@mgee.vip")


			//不同页面不同nav配色
			// if (url == "/newpro/Proclub") {
			// 	this.styleObject.backgroundColor = '#ffffff'
			// 	this.logourl = clogo
			// } else {
			// 	this.styleObject.backgroundColor = '#11161F'
			// 	this.logourl = wlogo
			// }
			var path = this.$route.path
			// 刷新进入页面判断在哪个index上
			path = path.toLowerCase()
			this.selectindex = this.setindex(path);


		},

		watch: {
			$route(to, form) {

				var path = this.$route.path
				// 刷新进入页面判断在哪个index上
				path = path.toLowerCase()
				this.selectindex = this.setindex(path);

			}
		},

		methods: {
			gopage: function(url) {
				var _this = this
				this.$router.push(url)
				// 隐藏弹窗
				for (var i = 0; i < this.showsubnav.length; i++) {
					_this.$set(_this.showsubnav, i, false)
				}
				//回到顶部
				this.gotop();
				this.showminiNav=false;
			},
			openMiniNav:function(){
				this.showminiNav=!this.showminiNav
			},
			setindex: function(url) {

				if (url.indexOf('newpro/') != -1) {
					return 1;
				} else if (url.indexOf('supply') != -1) {
					return 6;
				} else if (url.indexOf('solution/') != -1) {
					return 2;
				} else if (url.indexOf('news') != -1) {
					return 3;
				} else if (url.indexOf('about') != -1) {
					return 4;
				} else {
					return 0;
				}

			},


			opensubnav(index) {
				this.$parent.pageindex = index
				for (var i = 0; i < this.showsubnav.length; i++) {
					if (i != index) {
						this.$set(this.showsubnav, i, false)
					}
				}
				this.$set(this.showsubnav, index, !this.showsubnav[index])
			},
			gotop: function() {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
			},
			// 鼠标移到sub nav上
			showselect: function(event) {

				event.target.style.backgroundColor = "#E5E8EC"
				event.target.style.color = "#000000"
			},

			hideenselect: function(event) {
				event.target.style.color = "#999999"
				event.target.style.backgroundColor = ""
			},


		},

	}
</script>

<style>
	.navview {

		/* background:rgba(255,255,255,0.1) */
	}




	@media (max-width:999px) {
		.navtitleview {
			display: none;
		}

		.naviconbutton {}

		.navtitleviewleft {
			color: #999999;
			font-size: 16px;
			/* height: 100%;
			display: flex; */
		}

		.navtitle {
			width: 130px;
			text-align: center;
			height: 50px;
			line-height: 50px;
			background-color: rgba(17, 22, 31, 1);
		}

		.navtitleselect {
			width: 130px;
			text-align: center;
			height: 50px;
			line-height: 50px;
			background-color: rgba(17, 22, 31, 1);
			color: #E8C570;
			border-left: 2px solid #E8C570;
		}

		.subnavview {

			text-align: center;
			/* top: 60px; */
			/* margin-left: -70px; */
			/* position: absolute; */
			/* backgroundColor: 'rgba(17,22,31,0.9)' */
			background-color: rgba(17, 22, 31, 0.9);
			height: auto;
			width: auto;
			position: absolute;
			left: 130px;

		}

		.subnavitem {
			width: 300px;
			height: 35px;
			line-height: 35px;
			padding: 0px 10px 0px 10px;
		}
	}

	@media (min-width: 1000px) {
		.navtitleview {
			color: #999999;
			font-size: 16px;
			height: 100%;
			display: flex;
		}

		.naviconbutton {
			display: none;
		}

		.navtitleviewleft {
			display: none;
		}


		.navtitle {
			height: 78px;
			line-height: 80px;

		}

		.navtitleselect {
			height: 78px;
			line-height: 80px;
			color: #E8C570;
			border-bottom: 2px solid #E8C570;
		}



		.subnavview {
			text-align: center;
			/* top: 60px; */
			/* margin-left: -70px; */
			position: absolute;

			color: #333333;

		}



		.subnavitem {
			height: 35px;
			line-height: 35px;
			padding: 0px 10px 0px 10px;
		}
	}
</style>
